import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { JsonFileService, WebApiService } from "../../../_libs/web-api";
import { BaseWebApiService } from "./-base-webapi.service";

@Injectable({
	providedIn: "root",
})
export class ConfigService extends BaseWebApiService {
	private configBase = "./assets/configs";

	constructor(
		private jsonFileService: JsonFileService,
		private webApiService: WebApiService
	) {
		super();
	}

	public getConfig<T>(configName: string) {
		return this.jsonFileService.get<T>(this.getConfigFileUrl(configName));
	}

	private getConfigFileUrl(config): string {
		return this.configBase + "/" + config + ".config.json";
	}

	public getConfigFromDrupal(): Observable<any> {
		const url = `/api/signup/config`;
		return this.webApiService.get<any>(this.getFullUrl(url, true), false);
	}
}
